import { Footer } from "../components/Footer";
import { Nav } from "../components/Nav";
import ServiceDetails from "../components/ServiceDetails";
import { Seo } from "../components/Seo";

export default function Permitting() {
	return (
		<>
			<Seo title="Austin Site Plan & Development Permitting | Gova" description="Navigate City of Austin, county, and TCEQ development requirements with local civil engineering and permitting support." path="/permitting" serviceName="Site Plan and Development Permitting" />
			<Nav />
			<ServiceDetails
				service="permitting"
				onBack={() => window.history.back()}
			/>
			<Footer />
		</>
	);
}
